import React from 'react';
import { Field } from 'formik';
import { countryCodes } from 'utils/countryCodes';

interface IEntityFormProps {
  entity: {
    firstName: string;
    lastName: string;
    companyName: string;
    city: string;
    state: string;
    country: string;
    postalCode: string;
  };
  edit: boolean;
}

const EntityForm: React.FC<IEntityFormProps> = (props: IEntityFormProps) => {
  const { entity, edit } = props;

  return (
    <div className='vault-form-entity'>
      <div className='vault-form-row'>
        <div className='vault-form-combo'>
          <p className='vault-form-label'>First Name</p>
          <Field
            className='vault-form-input'
            name='entity.firstName'
            value={entity?.firstName}
            disabled={!edit}
          ></Field>
        </div>
        <div className='vault-form-combo'>
          <p className='vault-form-label'>Last Name</p>
          <Field
            className='vault-form-input'
            name='entity.lastName'
            value={entity?.lastName}
            disabled={!edit}
          ></Field>
        </div>
      </div>
      <div className='vault-form-row'>
        <div className='vault-form-combo'>
          <p className='vault-form-label'>Company Name</p>
          <Field
            className='vault-form-input'
            name='entity.companyName'
            value={entity?.companyName}
            disabled={!edit}
          ></Field>
        </div>
      </div>
      <div className='vault-form-row'>
        <div className='vault-form-combo'>
          <p className='vault-form-label'>City</p>
          <Field
            className='vault-form-input'
            name='entity.city'
            value={entity?.city}
            disabled={!edit}
          ></Field>
        </div>
        <div className='vault-form-combo'>
          <p className='vault-form-label'>State</p>
          <Field
            className='vault-form-input'
            name='entity.state'
            value={entity?.state}
            disabled={!edit}
          ></Field>
        </div>
      </div>
      <div className='vault-form-row'>
        <div className='vault-form-combo'>
          <p className='vault-form-label'>Country of Residence/Origin</p>
          <Field
            className='vault-form-input'
            as='select'
            name='entity.country'
            value={entity?.country}
            disabled={!edit}
          >
            {countryCodes.map((country, i) => {
              return (
                <option key={i} value={country.value}>
                  {country.label}
                </option>
              );
            })}
          </Field>
        </div>
        <div className='vault-form-combo'>
          <p className='vault-form-label'>Postal Code</p>
          <Field
            className='vault-form-input'
            name='entity.postalCode'
            value={entity?.postalCode}
            disabled={!edit}
          ></Field>
        </div>
      </div>
    </div>
  );
};

export default EntityForm;
